// extracted by mini-css-extract-plugin
export default {"button-box":"Cart_button-box__KfufL","footer":"Cart_footer__6fTJQ"};